const facebookCreateAccount = ({ fbServices }) => ({ params, resolve }) => {
  fbServices.facebookCreateAccount({ params, resolve })
}

export default facebookCreateAccount
